import { regexPanNumber } from "./regExp";
import { ENCRYPTED_URL } from "./urls";
var CryptoJS = require("crypto-js");
export const checkValidNumber = (phoneNo: string): boolean => {
  if (!phoneNo) {
    return true;
  } else if (
    phoneNo &&
    (phoneNo.startsWith('6') ||
      phoneNo.startsWith('7') ||
      phoneNo.startsWith('8') ||
      phoneNo.startsWith('9'))
  ) {
    return true;
  }
  return false;
};
export const checkEncrypted = (value: any) => {
  var encryptData = CryptoJS.AES.encrypt(JSON.stringify(value), ENCRYPTED_URL).toString();
  return encryptData
}

export const checkDecrypted = (encryptKey: any) => {
  const bytes = CryptoJS.AES.decrypt(encryptKey, ENCRYPTED_URL);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  const getDecryValue = JSON.parse(decryptedData);
  return getDecryValue
}

export const checkPanCard = (panNumber: string) => {
  if (!panNumber) return true;
  else if (panNumber && panNumber.match(regexPanNumber)) return true;
  return false;
};

export const checkLineBreak = (value: any) => {
  return value.replace(/[\r\n]+/gm, "");
}

export const separateCommaNumber = (value: any) => {
  let x = value;
  x = x.toString();
  var lastThree = x.substring(x.length - 3);
  var otherNumbers = x.substring(0, x.length - 3);
  if (otherNumbers != '')
    lastThree = ',' + lastThree;
  var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  return res;
}

export const calcPercentage = (percent: any, total: any) => {
  return parseInt(((percent / 100) * total).toFixed(2));
}

export function iOSDeviceChecked() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}